import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { isPluginActive } from 'helpers/whiteLabel';
import { PAYMENT_PLUGIN_STRIPE_PLAIN, PAYMENT_PLUGIN_STRIPE_CONNECT, PAYMENT_PLUGIN_PAYPAL_PLUS } from 'js/constants';

import PaymentConfigStripe from 'components/layout/whiteLabel/paymentConfig/PaymentConfigStripe';
import PaymentConfigPaypal from 'components/layout/whiteLabel/paymentConfig/PaymentConfigPaypal';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import Loader from 'components/layout/Loader';

class WhiteLabelPaymentConfig extends EntityPropsUpdater {
  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      changeEntity,
      disabled,
      inModal,
    } = this.props;

    console.log('ENTITY', entity);

    const isPaypalActive = isPluginActive(PAYMENT_PLUGIN_PAYPAL_PLUS, entity);
    const isStripePlainActive = isPluginActive(PAYMENT_PLUGIN_STRIPE_PLAIN, entity);
    const isStripeConnectActive = isPluginActive(PAYMENT_PLUGIN_STRIPE_CONNECT, entity);

    const sharedProps = {
      entity,
      entityLoaded,
      changeEntity,
      disabled,
      inModal,
      isStripePlainActive,
      isStripeConnectActive,
    };

    const isAnyPluginActive = isStripePlainActive || isStripeConnectActive || isPaypalActive;

    return (
      <div className="clearfix">
        {entityLoaded ? (
          isAnyPluginActive ? (
            <>
              <div>{(isStripePlainActive || isStripeConnectActive) && <PaymentConfigStripe {...sharedProps} />}</div>
              <div>{isPaypalActive && <PaymentConfigPaypal {...sharedProps} />}</div>
            </>
          ) : (
            <div>No payment plugins are active</div>
          )
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}
WhiteLabelPaymentConfig.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {};
};

export default injectIntl(connect(mapStateToProps)(WhiteLabelPaymentConfig));
